import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import InputBase from "@material-ui/core/InputBase";
import styles from "../Events.module.css";
import ToggleSwitch from "../ReusableComp/ToggleSwitch";
import remove from "../../../Icons/Event/remove.png";
import DeleteIcon from "@material-ui/icons/Delete";
import WebServiceMapping from "./WebServiceMapping";
import WebServiceBackdrop from "./WebServiceBackdrop.jsx";
import axios from "../../../axios";
import {
  fetchProcessModularData,
  fetchProcessTaskTemplate,
  fetchProcessGlobalTemplate,
} from "./../../../components/IFormDesignerLayout/RequestLogic";
import CustomizedAlert from "../../../ReusableComponents/Alert/CustomizedAlert";
import secureLocalStorage from "react-secure-storage";
import { getFormId } from "../../../components/IFormDesignerLayout/IFormDesignerLogic";
import { useTranslation } from "react-i18next";
import uuid from "react-uuid";
import { GetStateFromData } from "../../../components/CustomHooks/CustomHooks.js";
import downarrow_svg from "../../../Icons/Event/downarrow_svg.svg";
import uparrow_svg from "../../../Icons/Event/uparrow_svg.svg";
import secureSessionStorage from "../../../utils/secureSessionStorage.js";

const useStyles = makeStyles({
  root: {
    padding: 0,
  },
  table: {
    minWidth: 650,
  },
  comboWeb: {
    width: "250px",
    height: "32px",
    fontSize: "12px",
    margin: "10px 5px !important",
  },
  comboWebExec: {
    width: "120px",
    height: "32px",
    fontSize: "12px",
    margin: "10px 5px !important",
  },
});

const WebService = (props) => {
  const translationStyles1 =
    window?.psh_configs?.selectedLanguage === "ar" ||
    window?.psh_configs?.selectedLanguage === "ar-SA";
  const { t } = useTranslation();
  const contexts = GetStateFromData();

  const {
    microFrontendData,
    webServiceResponse,
    setwebServiceResponse,
    activePage,
    appId,
    setDataObjectsContent,
    setfilteredDataObject,
    dataObjectsContent,
    isPortal
  } = contexts.contexts;
  const classes = useStyles();
  const webJson = {
    Name: "",
    Oprn: "",
    TOI: "0",
    IsRestService: "",
    isOldWSScreen: "",
    BRMSEnabled: "false",
    RestScopeType: "",
    RestCreationMode: "",
    Parameters: {
      InputParameters: {
        Unbounded: "N",
        paramType: "",
        scope: "I",
        Id: "0",
        Variable: [],
      },
      ResponseParameters: {},
    },
  };
  const [rows, setRows] = React.useState(props?.defaultState || [webJson]);
  const [stateMapping, setStateMapping] = React.useState(false);
  const [webServiceData, setWebServiceData] = React.useState([]);
  const [openMappingBackdrop, setOpenMappingBackdrop] = React.useState(false);
  const [selectedWebService, setSelectedWebService] = React.useState({});
  const [mappingType, setMappingType] = React.useState("");
  const [rowIndex, setRowIndex] = React.useState(0);
  const [portalState, setPortalState] = React.useState(
    microFrontendData?.formPageType || microFrontendData?.processName
      ? "Processes"
      : "Portals"
  );
  const [alertData, setAlertData] = React.useState({
    open: false,
    showConfirm: "showNotification",
  });
  const launchpadKey=secureSessionStorage.getItem("Authorization") || JSON.parse(secureLocalStorage.getItem("launchpadKey"))?.token;
  var jwtToken = launchpadKey || undefined;

  useEffect(() => {
    if (microFrontendData?.componentType === "TF") {
      if (dataObjectsContent && Object.keys(dataObjectsContent).length === 0) {
        var jsonForProcess = {
          taskId: microFrontendData?.taskId,
          processdefId: microFrontendData?.processDefId,
          processState: microFrontendData?.statusType || "L",
        };

        fetchProcessTaskTemplate(jsonForProcess)
          .then((response) => {
            setDataObjectsContent(response.data["children"]);
            setfilteredDataObject(response.data["children"]);
          })
          .catch(function (error) {
            console.log("Error :: ", error);
          });
      }
    } else if (microFrontendData?.componentType === "GT") {
      if (dataObjectsContent && Object.keys(dataObjectsContent).length === 0) {
        var jsonForProcess = {
          globalTemplateId: microFrontendData?.templateId,
        };

        fetchProcessGlobalTemplate(jsonForProcess)
          .then((response) => {
            setDataObjectsContent(response.data["children"]);
            setfilteredDataObject(response.data["children"]);
          })
          .catch(function (error) {
            console.log("Error :: ", error);
          });
      }
    } else if (portalState === "Portals") {
      if (dataObjectsContent && Object.keys(dataObjectsContent).length === 0) {
        fetch("/mdm-rest/app/dataobjects", {
          method: "post",
          headers: {
            "Content-Type": "application/json",
            "Authorization": jwtToken,
          },
          body: JSON.stringify({
            parent_id: appId,
            type: "AP",
            sort_order: "A",
            order_by: "1",
            records_to_fetch: "30",
            mode: "tree",
          }),
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (content) {
            if (content?.status?.subject === "No Data Objects found.") {
              setDataObjectsContent([]);
              setfilteredDataObject([]);
            } else {
              if (content.data.data_objects !== undefined) {
                var data = JSON.stringify(content.data.data_objects);
                let formId = getFormId();
                const jsonData = {
                  formId: formId.toString() || activePage?.formId,
                  data: `${data}`,
                };
                axios
                  .post("/idesign/getDataObjectsforMapping", jsonData, {
                    withCredentials: true,
                  })
                  .then((response) => {
                    setDataObjectsContent(response.data["children"]);
                    setfilteredDataObject(response.data["children"]);
                  })
                  .catch(function (error) {
                    if (error.response) {
                    }
                    console.log("error is", error);
                  });
              }
            }
          })
          .catch((err) => {
            console.log("error is", err);
          });
      }
    } else if (portalState === "Processes") {
      if (dataObjectsContent && Object.keys(dataObjectsContent).length === 0) {
        var jsonForProcess = {
          formId: microFrontendData?.formDefId,
          processdefId: microFrontendData?.processId,
          processState: microFrontendData?.statusType,
          processName: microFrontendData?.processName,
        };

        fetchProcessModularData(jsonForProcess)
          .then((response) => {
            setDataObjectsContent(response.data["children"]);
            setfilteredDataObject(response.data["children"]);
          })
          .catch(function (error) {
            console.log("Error :: ", error);
          });
      }
    }
  }, [portalState]);

  useEffect(() => {
    if (props.updateHandler) {
      props.updateHandler("WebService", rows);
    }
  }, [rows]);

  function createWebServiceList(webServiceResponse1) {
    var webServiceList = [];
    const restServices = webServiceResponse1?.RestWebServiceList;
    if (restServices && restServices.length > 0) {
      for (let service of restServices) {
        let webObj = {
          serviceType: "REST",
          webService: service.MethodName,
          operation: service.RestScopeType === "G" ? "GET" : "POST",
          ...service,
        };
        webServiceList.push(webObj);
      }

      webServiceResponse1.SoapWebServiceList &&
        webServiceResponse1.SoapWebServiceList.length > 0 &&
        webServiceResponse1.SoapWebServiceList.map((value, index) => {
          value.RequestParameters = [];
          value.ResponseParameters = [];
          value.Parameters &&
            value.Parameters.length > 0 &&
            value.Parameters.map((value2, index2) => {
              if (value2.ParamScope === "I") {
                value.RequestParameters.push(value2);
              } else if (value2.ParamScope === "R") {
                value.ResponseParameters.push(value2);
              }
            });
        });
    }
    const soapServices = webServiceResponse1?.SoapWebServiceList;
    if (soapServices && soapServices.length > 0) {
      for (let service of soapServices) {
        let webObj = {
          serviceType: "SOAP",
          webService: service.AppName,
          operation: service.MethodType === "G" ? "GET" : "POST",
          ...service,
        };
        webServiceList.push(webObj);
      }
    }
    setWebServiceData(webServiceList);
  }
  useEffect(() => {
    const cabinet = secureLocalStorage.getItem("cabinet");
    var jwtToken =
      JSON.parse(
        secureLocalStorage.getItem(
          window.isPortalLive
            ? `launchpadKey_${window.applicationName}` || `launchpadKey_bypass_${window.applicationName}` || "launchpadKey"
            : "launchpadKey"
        )
      )?.token || undefined;
    let formId = getFormId();
    if (!webServiceResponse) {
      let payload = {
        processdefId: !isPortal ? microFrontendData?.processDefId || microFrontendData?.processId : null,
        formId: formId.toString(),
        cabinetName: cabinet,
        processState:!isPortal ? microFrontendData?.processState || microFrontendData?.statusType : null,
        token: jwtToken,
      };
      axios
        .post("/idesign/getWebservices", payload, { withCredentials: true })
        .then((response) => {
          setwebServiceResponse(response.data);
          createWebServiceList(response.data);
        });
    } else {
      createWebServiceList(webServiceResponse);
    }
  }, []);

  const AddRow = () => {
    setRows([...rows, webJson]);
  };
  const DeleteRow = (i) => {
    let temp = [...rows];
    temp.splice(i, 1);
    setRows(temp);
  };

  const xmlData = {
    EE_EAI_MESSAGE: {
      EE_EAI_HEADER: {
        RequestorLanguage: "",
        ReturnCode: "",
        RequestorSecurityInfo: "",
        RequestorChannelId: "",
        RequestorUserId: "",
        MsgFormat: "",
        MsgVersion: "",
        Extra2: "",
        Extra1: "",
        ReturnDesc: "",
        MessageId: "",
      },
      CustomerExposureResponse: {
        ReferenceNumber: "",
        ReportUrl: "",
        IsDirect: "",
        CustInfo: {
          NoOfContracts: "",
          FullNm: "",
          TotalOverdue: "",
          Activity: "",
          TotalOutstanding: "",
        },
        RequestType: "",
      },
    },
  };
  function showAlertConfirmNotifications(dataTobeSet) {
    setAlertData(dataTobeSet);
  }
  function handleInputMapping(index, type, service) {
    let name = service.Name || service.MethodName;
    setMappingType(type);
    setServiceForMapping(name);
    if (portalState === "Portals") {
      if (portalState === "Portals" && dataObjectsContent.length > 0) {
        setOpenMappingBackdrop(true);
      } else {
        showAlertConfirmNotifications({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentKey: "Define Data Object First",
        });
      }
    } else {
      setOpenMappingBackdrop(true);
    }
  }

  function setServiceForMapping(serviceName) {
    let seleted = webServiceData.filter(
      (service) => serviceName === service.webService
    );
    setSelectedWebService({ ...seleted[0] });
  }
  function handleInputService(e, index) {
    let name = e.target.value;
    var requiredWebService;
    for (let i of webServiceData) {
      if (i.MethodName == name || i.AppName == name) {
        requiredWebService = i;
      }
    }
    setRowIndex(index);
    rows[index].Name = name;
    rows[index].Oprn =
      requiredWebService?.RestScopeType || requiredWebService?.MethodName;
    rows[index].TOI = "0";
    rows[index].IsRestService =
      requiredWebService?.serviceType === "REST" ? "true" : "false";
    rows[index].isOldWSScreen = "true";
    rows[index].BRMSEnabled = requiredWebService?.BRMSEnabled
      ? requiredWebService?.BRMSEnabled
      : false;
    rows[index].RestScopeType = requiredWebService?.RestScopeType
      ? requiredWebService?.RestScopeType
      : "G";
    rows[index].RestCreationMode = requiredWebService?.RestCreationMode
      ? requiredWebService?.RestCreationMode
      : "M";
    rows[index].BaseUri = requiredWebService?.BaseURI
      ? requiredWebService?.BaseURI.trim()
      : requiredWebService?.WSDLLocation
      ? requiredWebService?.WSDLLocation.trim()
      : "";
    rows[index].ResourcePath = requiredWebService?.ResourcePath
      ? requiredWebService?.ResourcePath.trim()
      : "";
    rows[index].RequestMediaType = requiredWebService?.RequestMediaType;
    rows[index].ResponseMediaType = requiredWebService?.ResponseMediaType;
    rows[index].OperationCode = requiredWebService?.operation;
    rows[index].MethodIndex = requiredWebService?.MethodIndex;
    rows[index].AuthenticationType = requiredWebService?.AuthenticationType;
    rows[index].ProxyEnabled = requiredWebService?.ProxyEnabled;
    rows[index].AuthenticationDetails = "";
    rows[index].WSDL =
      requiredWebService?.serviceType === "REST"
        ? "WSDL"
        : requiredWebService?.WSDLLocation.trim();
    rows[index].Parameters = {
      InputParameters: {
        unbounded: "N",
        paramName: "InputParameters",
        paramType: "",
        scope: "I",
        id: "0",
        Variable: [],
      },
      ResponseParameters: {
        id: 1,
        paramName: "ResponseParameters",
        scope: "R",
        paramType: "",
        unbounded: "N",
        Variable: [],
      },
    };
    rows[index].mappedControls = "";
    setRows([...rows]);
    setServiceForMapping(name);
  }

  function setTOI(value, index) {
    rows[index].TOI = `${value}`;
  }

  return (
    <div className={styles.tableclass}>
      <div className={styles.eventheader}>
        <span>{t("Web Service")}</span>
        <span>
          <span
            className={styles.addrowbtn}
            style={
              translationStyles1
                ? { marginLeft: "20px", marginRight: "unset" }
                : null
            }
            onClick={() => {
              AddRow();
            }}
          >
            {t("+ Add Link")}
          </span>
          <span>
            <DeleteIcon
              onClick={() => {
                props.handleDelete(props.name);
              }}
            ></DeleteIcon>
            {
            props?.openedAccordian === props?.name
            ?
            <img
              src={downarrow_svg}
              onClick={props.setopenedAccordian(props?.name)}
              style={{
                width:"24px", 
                height :"24px",
                margin:"0px 0 0 8px" 
              }}
            />
            :
            <img
              onClick={props.setopenedAccordian("")}
              src={uparrow_svg}
              style={{
                width:"24px", 
                height :"24px",
                margin:"0px 0 0 8px" 
              }}
            />
            }
          </span>
        </span>
      </div>
      <TableContainer>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow style={{ height: "40px" }}>
              <TableCell
                className={styles.tableelementhead}
                style={{
                  minWidth: "53px",
                  textAlign: "center",
                }}
                align="center"
              >
                {t("S No.")}
              </TableCell>
              <TableCell
                className={styles.tableelementhead}
                style={{ width: "97px", textAlign: "center" }}
                align="center"
              >
                {t("Complex Structure")}
              </TableCell>
              <TableCell
                className={styles.tableelementhead}
                style={{ widht: "201px", textAlign: "center" }}
                align="center"
              >
                {t("Web Service")}
              </TableCell>
              <TableCell
                className={styles.tableelementhead}
                style={{ width: "123px", textAlign: "center" }}
                align="center"
              >
                {t("Operations")}
              </TableCell>
              <TableCell
                className={styles.tableelementhead}
                style={{ width: "72px", textAlign: "center" }}
                align="center"
              >
                {t("Time Out")}
              </TableCell>
              <TableCell
                className={styles.tableelementhead}
                style={{ width: "99px", textAlign: "center" }}
                align="center"
              >
                {t("Input")}
              </TableCell>
              <TableCell
                style={{ width: "41px", textAlign: "center" }}
                align="center"
              ></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index1) => {
              return (
                <TableRow
                  key={`${uuid()}_${index1}`}
                  style={{ height: "53px" }}
                >
                  <TableCell className={styles.tableelement} align="center">
                    {index1 + 1}
                  </TableCell>
                  <TableCell className={styles.tableelement} align="center">
                    <ToggleSwitch></ToggleSwitch>
                  </TableCell>
                  <TableCell className={styles.tableelement} align="center">
                    <select
                      className={classes.comboWeb}
                      onChange={(e) => handleInputService(e, index1)}
                    >
                      <option value="Select" key={index1}>
                        {t("Select")}
                      </option>
                      {webServiceData.map((service, index) => {
                        return (
                          <>
                            <option
                              value={service.webService}
                              key={index}
                              selected={
                                rows[index1].Name === service.webService
                                  ? true
                                  : false
                              }
                            >
                              {service.webService}
                            </option>
                          </>
                        );
                      })}
                    </select>
                  </TableCell>
                  <TableCell className={styles.tableelement} align="center">                    
                    <div
                        style={{
                          height: "29px",
                          margin: "auto",
                        }}
                      >
                    <InputBase
                      disabled
                      aria-label={"Control Value1"}
                      style={{
                        height: "28px",
                        margin: "0px 10px"
                      }}
                      inputProps={{
                        "aria-label": "Control Value1",
                        style:{
                          textAlign:"center"
                        }
                      }}
                      key={`${uuid()}-${index1}`}
                      defaultValue={
                        rows[index1].Oprn === "G" ? "GET" : rows[index1].Oprn === "P" ? "POST" : rows[index1].Oprn
                      }
                    />
                    </div>
                  </TableCell>
                  <TableCell className={styles.tableelement} align="center">
                    <span className={styles.defaultbtn}>
                      <div
                        style={{
                          width: "54px",
                          height: "29px",
                          border: "1px solid #c4c4c4",
                          margin: "auto",
                          borderRadius: "5px"
                        }}
                      >
                        <InputBase
                          aria-label={"Control Value1"}
                          style={{
                            width: "54px",
                            height: "28px",
                          }}
                          inputProps={{
                            "aria-label": "Control Value1",
                            style:{
                          height:"100%"
                        }
                          }}
                          type="number"
                          key={`${uuid()}-${index1}`}
                          defaultValue={
                            rows[index1]?.TOI === "0" ? "" : rows[index1]?.TOI
                          }
                          onBlur={(e) => {
                            setTOI(e.target.value, index1);
                          }}
                        />
                      </div>
                    </span>
                  </TableCell>
                  <TableCell className={styles.tableelement} align="center">
                    <span
                      className={styles.defaultbtn}
                      onClick={() =>
                        handleInputMapping(index1, "input", rows[index1])
                      }
                    >
                      {t("Map Parameters")}
                    </span>
                  </TableCell>
                  {stateMapping === index1 ? (
                    <WebServiceMapping
                      stateOpen={true}
                      index={index1}
                      stateJsonBeforeSaving={xmlData}
                      setStateMapping={setStateMapping}
                    />
                  ) : null}
                  <TableCell className={styles.lastelement} align="center">
                    <span
                      className={styles.defaultbtn}
                      onClick={() => {
                        DeleteRow(index1);
                      }}
                    >
                      <img src={remove} alt="remove" />
                    </span>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      {openMappingBackdrop === true ? (
        <WebServiceBackdrop
          rowData={rows[rowIndex]}
          selectedWebService={selectedWebService}
          mappingType={mappingType}
          mappingDialogOpen={openMappingBackdrop}
          setMappingDialogOpen={setOpenMappingBackdrop}
        />
      ) : null}
      {alertData.open === true && <CustomizedAlert alertData={alertData} />}
    </div>
  );
};

export default WebService;
